import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class AnalyticsService {
  public settings: any = {
    pageTracking: {
      autoTrackVirtualPages: true,
      excludedRoutes: [],
    },
    eventTracking: {},
  };
  public pageTrack: ReplaySubject<any> = new ReplaySubject(10);
  public eventTrack: ReplaySubject<any> = new ReplaySubject(10);
  public setUsername: ReplaySubject<any> = new ReplaySubject(10);
  public setUserProperties: ReplaySubject<any> = new ReplaySubject(10);
  public setUserPropertiesOnce: ReplaySubject<any> = new ReplaySubject(10);
  public setSuperProperties: ReplaySubject<any> = new ReplaySubject(10);
  public setSuperPropertiesOnce: ReplaySubject<any> = new ReplaySubject(10);

  constructor(location: Location, router: Router) {
    this.trackLocation(location, router);
  }

  excludeRoutes(routes: (string | RegExp)[]) {
    this.settings.pageTracking.excludedRoutes = routes;
  }

  trackLocation(location: Location, router: Router) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => this.trackUrlChange(event.urlAfterRedirects, location));
  }

  protected trackUrlChange(url: string, location: Location) {
    if (this.settings.pageTracking.autoTrackVirtualPages && !this.isRouteExcluded(url)) {
      this.pageTrack.next({ path: url, location: location });
    }
  }

  protected isRouteExcluded(url: string): boolean {
    for (let excludedRoute of this.settings.pageTracking.excludedRoutes) {
      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
        return true;
      }
    }
    return false;
  }
}
